var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.4447L24.7376 13.7071C25.1281 13.3166 25.7613 13.3166 26.1518 13.7071L26.2929 13.8482C26.6834 14.2387 26.6834 14.8719 26.2929 15.2624L21.5553 20L26.2929 24.7376C26.6834 25.1281 26.6834 25.7613 26.2929 26.1518L26.1518 26.2929C25.7613 26.6834 25.1281 26.6834 24.7376 26.2929L20 21.5553L15.2624 26.2929C14.8719 26.6834 14.2387 26.6834 13.8482 26.2929L13.7071 26.1518C13.3166 25.7613 13.3166 25.1281 13.7071 24.7376L18.4447 20L13.7071 15.2624C13.3166 14.8719 13.3166 14.2387 13.7071 13.8482L13.8482 13.7071C14.2387 13.3166 14.8719 13.3166 15.2624 13.7071L20 18.4447Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/closeGray.e85db7a3c212bef7c4f667597ea5e494.svg";
export { ForwardRef as ReactComponent };